import { Api } from "common-components";

export const getBasicSelection = async () => {
	const response = await Api.get(
		`${process.env.REACT_APP_DOMAIN}/api/open/basicselection?mergeSchoolYear=false&includeParent=false`,
	);
	return response;
};
